import script from "./PlatformDynamicsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDynamicsDetail.vue?vue&type=script&setup=true&lang=js"

import "./PlatformDynamicsDetail.vue?vue&type=style&index=0&id=6344aeee&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6344aeee"]])

export default __exports__